const ACCESS_TOKEN = 'accessToken';

const PAGE_PATHS = 'pagePaths';

const RAW_PAGE_CAR_CODE = 'rawPageCarCode';

class SessionManager {
    getAccessToken = () => {
        return sessionStorage.getItem(ACCESS_TOKEN);
    };

    setAccessToken = (accessToken) => {
        sessionStorage.setItem(ACCESS_TOKEN, accessToken);
    };

    getPagePaths = () => {
        const pagePathsStr = sessionStorage.getItem(PAGE_PATHS);
        let pagePaths = [];
        if (pagePathsStr && (pagePathsStr.length > 0)) {
            pagePaths = pagePathsStr.split(',');
        }
        return pagePaths;
    };

    setPagePaths = (pagePaths) => {
        sessionStorage.setItem(PAGE_PATHS, pagePaths.toString());
    };

    getRawPageCarCode = () => {
        return sessionStorage.getItem(RAW_PAGE_CAR_CODE);
    };

    setRawPageCarCode = (rawPageCarCode) => {
        sessionStorage.setItem(RAW_PAGE_CAR_CODE, rawPageCarCode);
    };
};

export default SessionManager;